import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=041cdd20&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cdd20",
  null
  
)

export default component.exports